/**
 * Returns whether the given object matches the CesiumIonAssetType type
 * @param obj Object to check
 */
export function isCesiumIonAssetType(obj) {
    if (typeof obj !== "string")
        return false;
    switch (obj) {
        case "3DTILES" /* CesiumIonAssetType.Tiles */:
        case "GLTF" /* CesiumIonAssetType.Gltf */:
        case "IMAGERY" /* CesiumIonAssetType.Imagery */:
        case "TERRAIN" /* CesiumIonAssetType.Terrain */:
        case "KML" /* CesiumIonAssetType.Kml */:
        case "CZML" /* CesiumIonAssetType.Czml */:
        case "GEOJSON" /* CesiumIonAssetType.GeoJson */:
            return true;
        default:
            return false;
    }
}
